export default{
  getSearchClassUserSchool: (state) => state.searchClassUserSchool,
  getSearchClassUserLevel: (state) => state.searchClassUserLevel,
  getSearchClassUserFacult: (state) => state.searchClassUserFacult,
}



// WEBPACK FOOTER //
// ./src/components/class-users/store/getters.js